import { type StoreActionApi } from 'react-sweet-state';

import type { ChatMessageResearchStore } from './types';
import { updateStep } from './updateStep';

type AppendStepContentArgs = {
	messageId: string;
	stepId: string;
	content: string;
	isStreamed: boolean;
	immediate: boolean;
	roundId: number;
};

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const appendStepContent: (args: AppendStepContentArgs) => ChatMessageResearchStoreAction =
	({ messageId, stepId, content, isStreamed, immediate, roundId }) =>
	({ dispatch }: StoreActionApi<ChatMessageResearchStore>) => {
		dispatch(
			updateStep({
				messageId,
				stepId,
				updater: (step, isNewStep) => {
					// Concat once and reuse to halve per-event allocation.
					const concatenatedContent = (step.content ?? '') + content;
					// streamed: single concatenated child; non-streamed: each chunk as a separate array item
					const separatedContent = isStreamed
						? [concatenatedContent]
						: [...step.separatedContent, content];
					return {
						...step,
						roundId,
						content: concatenatedContent,
						separatedContent,
						immediate,
						// If a step content arrives for a step that was never introduced with a title,
						// consider it completed immediately — it's an orphan content step that won't
						// receive a RESEARCH_STEP_COMPLETE message.
						// Otherwise, it cannot be complete if we're still appending content.
						completed: isNewStep && !step.title ? true : false,
						// Track whether this step's content is streamed or discrete
						isStreamed,
					};
				},
			}),
		);
	};
